/* eslint-disable react/no-array-index-key */
import React from 'react';

// import { PublicClientApplication } from '@azure/msal-browser';
import { ShoppingCartOutlined } from '@mui/icons-material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import {
  Grid,
  Typography,
  Paper,
  Divider,
  Stack,
  Avatar,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Button,
} from '@mui/material';
import { deepPurple } from '@mui/material/colors';

import { COLOR } from '../../helpers/colors';
import { formatAmount, getAvatarText, roundToTwoDecimals } from '../../helpers/functions';
// import { msalConfig } from '../../helpers/config';
const menuItemTextStyle = {
  backgroundColor: 'transparent',
  alignItems: 'center',
  paddingY: 0.75,
  pr: 1.5,
  pl: 4,
  fontSize: 14,
  mb: 0,
  cursor: 'pointer',
  color: COLOR.menuItemColor,
  ':hover': {
    backgroundColor: COLOR.bgColorVariant,
    color: COLOR.linkColor2,
    fontWeight: 'bold',
  },
};
export const getMenuData = (t, history) => {
  const { pathname } = history.location;
  return [
    {
      label: () => t('PRODUCTS'),
      icon: CloudUploadOutlinedIcon,
      onClick: () => {
        history.push('/products');
      },
      isActive: pathname === '/products' || pathname.includes('/products'),
    },
    {
      label: () => t('QUOTATIONS'),
      icon: SearchOutlinedIcon,
      onClick: () => {
        history.push('/quotations');
      },
      isActive: pathname === '/quotations' || pathname.includes('/quotations'),
    },
    // {
    //   label: () => t('ORDERS'),
    //   icon: SearchOutlinedIcon,
    //   onClick: () => {
    //     history.push('/orders');
    //   },
    //   isActive: pathname === '/orders' || pathname.includes('/orders'),
    // },
    {
      label: () => t('UPLOAD'),
      icon: CloudUploadOutlinedIcon,
      onClick: () => {
        history.push('/upload');
      },
      isActive: pathname === '/upload',
    },
    {
      label: () => t('BILLING'),
      icon: CloudUploadOutlinedIcon,
      onClick: () => {
        history.push('/billing');
      },
      isActive: pathname === '/billing',
    },
    {
      label: () => t('DELIVERY'),
      icon: CloudUploadOutlinedIcon,
      onClick: () => {
        history.push('/delivery');
      },
      isActive: pathname === '/delivery',
    },

    // {
    //   label: () => 'Create Inquiry',
    //   icon: CloudUploadOutlinedIcon,
    //   onClick: () => {
    //     history.push('/createInquiry');
    //   },
    //   isActive: pathname === '/createInquiry',
    // },
  ];
};

export const getLanguages = t => {
  return [
    {
      label: () => t('ENGLISH'),
      value: 'English',
      code: 'en',
    },
    {
      label: () => t('ARABIC'),
      value: 'Arabic',
      code: 'ar',
    },
  ];
};

export const getCountries = () => {
  return [
    {
      label: () => 'UAE',
      value: 'Dubai',
      code: 'UAE',
    },
    // {
    //   label: () => t('INDIA'),
    //   value: 'India',
    //   code: 'IN',
    // },
  ];
};

export const getCurrencies = t => {
  return [
    {
      label: () => t('INDIA'),
      value: 'INR',
      code: 'INR',
    },
    {
      label: () => t('USA'),
      value: 'USD',
      code: 'USD',
    },
    {
      label: () => t('DUBAI'),
      value: 'AED',
      code: 'AED',
    },
  ];
};

// const msalInstance = new PublicClientApplication(msalConfig);

export const getIcons = props => {
  const { cart, t, history, checkout } = props;
  const { cartItems } = cart;
  const { shipToPartyDataArr } = checkout;
  const addressData =
    shipToPartyDataArr.length > 0 ? shipToPartyDataArr[0] : { BusinessPartnerName: '' };
  let totalQty = 0;
  let subTotal = 0;
  const { pathname } = props.history.location;
  const isCheckoutPage = pathname === '/checkout';

  let isShowSnackbar = false;
  cartItems.forEach(c => {
    if (c.available) {
      subTotal += (roundToTwoDecimals(c.Price), +roundToTwoDecimals(c.Tax)) * c.qty;
      totalQty += c.qty;
    } else {
      isShowSnackbar = true;
    }
  });
  const Currency = cartItems.length > 0 ? cartItems[0].Currency : '';

  return [
    {
      label: () => t('FAVS'),
      icon: FavoriteBorderOutlinedIcon,
      onClick: event => {
        event.stopPropagation();
        history.push('/favorite');
      },
      showMenu: false,
      showBadge: false,
    },

    {
      label: () => t('PROFILE'),
      icon: PersonOutlineIcon,
      onClick: event => {
        event.stopPropagation();
        history.push('/profile');
      },
      showMenu: true,
      showBadge: false,
      body: () => {
        return (
          <Paper sx={{ width: 200, pt: 1, pb: 1 }} square classes={{ paper: 'MuiPopover-paper' }}>
            <Stack
              sx={{ pl: 3, pr: 3, pt: 2, pb: 2 }}
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Avatar sx={{ bgcolor: deepPurple[500], fontSize: 14, mr: 1 }}>
                {getAvatarText(addressData.BusinessPartnerName)}
              </Avatar>
              <Typography variant="subtitle2" component="div">
                {addressData.BusinessPartnerName}
              </Typography>
            </Stack>
            <Divider />

            <Typography
              sx={menuItemTextStyle}
              variant="subtitle2"
              onClick={() => props.history.push('/profile')}
            >
              {t('libraryScreenTranslations:MY_PROFILE')}
            </Typography>
            <Typography
              sx={menuItemTextStyle}
              variant="subtitle2"
              onClick={() => props.history.push('/complaint')}
            >
              {t('libraryScreenTranslations:COMPLAINT')}
            </Typography>

            <Typography
              sx={menuItemTextStyle}
              variant="subtitle2"
              onClick={() => {
                props.handleSalesOrgDialog(true);
                history.push('/');
              }}
            >
              {t('mainScreenTranslations:SALES_ORGANIZATION')}
            </Typography>
            <Typography
              sx={menuItemTextStyle}
              variant="subtitle2"
              onClick={async () => {
                try {
                  const msalInstance = props.msalContext.instance;
                  await msalInstance.logoutPopup();
                  props.logUserOut();
                  props.selectSalesOrg({});
                } catch (err) {
                  console.log(err);
                }
              }}
            >
              {t('libraryScreenTranslations:SIGNOUT')}
            </Typography>
          </Paper>
        );
      },
    },
    {
      label: () => t('CART'),
      icon: ShoppingCartOutlined,
      onClick: event => {
        event.stopPropagation();
        history.push('/cart');
      },
      showBadge: true,
      showMenu: isCheckoutPage === false,
      badgeContent: totalQty,
      invisible: totalQty === 0,
      body: () => {
        const dir = props.i18n.dir();
        return (
          <Paper square sx={{ paddingX: 2, pb: 2, width: 300 }}>
            {totalQty > 0 ? (
              <Grid>
                <Grid sx={{ maxHeight: 300, overflowY: 'auto', p: 0 }}>
                  <Table aria-label="simple table">
                    <TableBody>
                      {cartItems.map((c, index) => (
                        <TableRow
                          key={index.toString()}
                          sx={{
                            '&:last-child td, &:last-child th': { border: 0 },
                          }}
                        >
                          <TableCell
                            component="th"
                            scope="row"
                            align="left"
                            sx={{ paddingY: 1.5, paddingX: 1, verticalAlign: 'middle' }}
                          >
                            <Grid
                              container
                              direction="row"
                              justifyContent="flex-start"
                              alignItems="center"
                            >
                              <img
                                src="/item_l.jpg"
                                alt=""
                                loading="lazy"
                                style={{ width: 50, height: 50 }}
                              />
                              <Grid item>
                                <Typography
                                  className="c-title"
                                  style={{
                                    fontSize: 14,
                                  }}
                                >
                                  {c.MaterialName.length > 18
                                    ? `${c.MaterialName.substr(0, 15)}...`
                                    : c.MaterialName}
                                </Typography>
                                <Typography
                                  style={{
                                    fontSize: 12,
                                    color: COLOR.helperTextColor,
                                  }}
                                >
                                  {c.qty} x {formatAmount('en-AE', c.Price, c.Currency)}
                                </Typography>
                              </Grid>
                            </Grid>
                          </TableCell>

                          <TableCell
                            align="center"
                            valign="middle"
                            sx={{ paddingY: 1.5, paddingX: 1, verticalAlign: 'middle' }}
                          >
                            <CloseOutlinedIcon
                              color="error"
                              sx={{ cursor: 'pointer' }}
                              fontSize="inherit"
                              onClick={() => props.removeItem(c.Material)}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Grid>

                <Divider />
                <Stack direction="row" justifyContent="flex-end" sx={{ pt: 2, pb: 2 }}>
                  <Typography
                    sx={{
                      color: COLOR.helperTextColor,
                      fontSize: 14,
                      mr: dir === 'rtl' ? 0 : 1,
                    }}
                  >
                    {t('libraryScreenTranslations:SUBTOTAL')}:
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: 14,
                      mr: dir === 'rtl' ? 1 : 0,
                    }}
                  >
                    {/* {subTotal} */}
                    {formatAmount('en-AE', subTotal, Currency)}
                  </Typography>
                </Stack>
                <Stack direction="row" justifyContent="space-between">
                  <Button
                    variant="outlined"
                    color="inherit"
                    sx={{ fontSize: 12, width: '100%', mr: dir === 'rtl' ? 0 : 1 }}
                    onClick={() => history.push('/cart')}
                  >
                    {t('libraryScreenTranslations:EXP_CART')}
                  </Button>

                  <Button
                    variant="contained"
                    color="primary"
                    sx={{ fontSize: 12, width: '100%', mr: dir === 'rtl' ? 1 : 0 }}
                    onClick={() => {
                      return !isShowSnackbar
                        ? props.history.push({
                            pathname: '/checkout',
                            state: { isCheckout: true },
                          })
                        : props.history.push('/cart');
                    }}
                  >
                    {t('libraryScreenTranslations:CHECKOUT')}
                  </Button>
                </Stack>
              </Grid>
            ) : (
              <Grid
                container
                direction="row"
                justifyContent="center"
                style={{
                  paddingY: 2,
                  paddingX: 0.75,
                }}
              >
                <Grid item>
                  <Typography style={{ fontSize: 18, color: COLOR.helperTextColor }}>
                    {t('libraryScreenTranslations:CART_EMPTY')}
                  </Typography>
                </Grid>
              </Grid>
            )}
          </Paper>
        );
      },
    },
  ];
};
